import React, { useState } from 'react'
import { Avatar, Empty, Tag } from 'antd'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faClone, faEdit, faPlus, faTrash } from '@fortawesome/free-solid-svg-icons'
import { ItensPerUserLogged } from '../../../../../services/login/permissaoUsuarioLoado'
import { removerAcentos } from '../../../../../utils'
import { Box } from '../../../../../Components/CustomUi/box'
import { Inline } from '../../../../../Components/CustomUi/inline'
import Input from '../../../../../Components/CustomUi/input'
import ButtonCustom from '../../../../../Components/ButtonCustom'
import { HeaderTable } from '../../../../../Components/CustomUi/table/headerTable'
import { BodyTable } from '../../../../../Components/CustomUi/table/bodyTable'
import { Render } from '../../../../../Components/CustomUi/render'
import { RowTable } from '../../../../../Components/CustomUi/table/rowTable'
import { RowItem } from '../../../../../Components/CustomUi/table/rowItem'
import { DeleteButton } from '../../../../../Components/CustomUi/deleteButton'
import Carregando from '../../../../../Components/CustomUi/loading'
import { Switcher } from '../../../../../Components/CustomUi/Switcher'
import GeneratePdfButton from '../../../../../Components/relatorio-component'

//PROPS
interface Props {
  loading: boolean
  list_clientes: any[]
  deletar: Function
  abrir?: Function
  editar?: Function
  permissao: ItensPerUserLogged
  buscarTabela: string
  setBuscarTabela: React.Dispatch<React.SetStateAction<string>>
  setPagination: React.Dispatch<React.SetStateAction<number>>
  page?: number
  setPage: React.Dispatch<React.SetStateAction<number>>
  total: number
  confirmar_exclusao: boolean
  setConfirmar_exclusao: React.Dispatch<React.SetStateAction<boolean>>
  id_item_atual: number
  setId_item_atual: React.Dispatch<React.SetStateAction<number>>
  nome_item_atual: string
  setNome_item_atual: React.Dispatch<React.SetStateAction<string>>
  fake_loading: boolean
  setFake_loading: React.Dispatch<React.SetStateAction<boolean>>
  inativos: boolean
  setInativos: React.Dispatch<React.SetStateAction<boolean>>
  handleChangeSwitchStatus: Function
  dadosEstatisticas: any[]
  dadosResultado: any[]
}

export const TabelaClientes: React.FC<Props> = ({
  list_clientes,
  loading,
  deletar,
  abrir,
  setPagination,
  editar,
  page,
  buscarTabela,
  setBuscarTabela,
  setPage,
  total,
  confirmar_exclusao,
  setConfirmar_exclusao,
  id_item_atual,
  setId_item_atual,
  nome_item_atual,
  setNome_item_atual,
  fake_loading,
  setFake_loading,
  permissao,
  inativos,
  setInativos,
  handleChangeSwitchStatus,
  dadosEstatisticas,
  dadosResultado
}) => {
  console.log(loading)

  function buscarFornecedores(buscar_nome: string) {
    const palavraSemAcentos = removerAcentos(buscar_nome)
    return function (item) {
      const nomeSemAcentos = removerAcentos(String(item?.nome))

      return nomeSemAcentos.toLowerCase().includes(palavraSemAcentos.toLowerCase()) || !buscar_nome
    }
  }

  // const fornecedoresFiltrados = list_clientes.filter((item) =>
  //   item.tags?.some((produto) => produto.toLowerCase().includes(buscarTabela.toLowerCase()))
  // )

  // console.log('fornecedor', fornecedoresFiltrados)

  // function removerUltimosDigitos(value) {
  //   if (!value) return ''
  //   // Remove qualquer caractere que não seja número
  //   const numericValue = value.replace(/\D/g, '')
  //   // Retorna o valor sem os dois últimos dígitos
  //   return numericValue.slice(0, -2)
  // }

  return (
    <Box borderless style={{ height: 'calc(100vh - 170px)' }}>
      <Inline alignItems='center'>
        <Input placeholder='Buscar clientes' value={buscarTabela} onChange={setBuscarTabela} />
        <ButtonCustom icon={<FontAwesomeIcon icon={faPlus} />} onClick={abrir}>
          Novo
        </ButtonCustom>
        <GeneratePdfButton
          dados={dadosEstatisticas}
          title={'Relatório de clientes'}
          totais={dadosResultado}
          disable={list_clientes?.length <= 0}
        />
      </Inline>
      <Switcher label='Ocultar clientes inativos' isChecked={inativos} trigger={setInativos} />
      <HeaderTable
        itens={[
          { valor: 'Ativo', width: '81px' },
          { valor: 'Logo', width: '60px' },
          { valor: 'Nome', width: 'calc(100% - 766px)' },
          { valor: 'Razão social', width: '400px' },
          { valor: 'Ações', width: '220px' },
        ]}
      />

      <BodyTable
        paginate={total}
        onChangeItensPage={setPagination}
        onChangePage={setPage}
        current_page={page}
        setCurrent_page={setPage}
        style={{
          height: (list_clientes ?? []).length < 8 && 'calc(100vh - 170px)',
          position: 'relative',
          overflowX: 'hidden',
          overflowY: 'scroll',
          marginTop: -10,
        }}
      >
        <Render condition={!loading}>
          {(list_clientes ?? []).filter(buscarFornecedores(buscarTabela)).map((item, index) => {
            const icone = item?.nome.split(' ')
            return (
              <RowTable key={item?.cod} onDoubleClick={() => editar(item?.cod, item)}>
                <RowItem fontSize={13} width={'80px'}>
                  {
                    <Switcher
                      isChecked={item?.status}
                      trigger={() => handleChangeSwitchStatus(item?.cod, index, item?.status)}
                    />
                  }
                </RowItem>
                <RowItem fontSize={13} width={'60px'}>
                  {
                    <Avatar src={item?.logo}>
                      <b>
                        {item?.nome?.[0]?.substring(0, 1).toUpperCase()}
                        {item?.nome?.[1]?.substring(0, 1).toUpperCase()}
                      </b>
                    </Avatar>
                  }
                </RowItem>
                <RowItem fontSize={13} width={'calc(100% - 760px)'}>
                  {item?.nome}
                </RowItem>
                <RowItem fontSize={13} width={'400px'}>
                  {item?.razao_social}
                </RowItem>
                <RowItem width={'220px'} gap={10}>
                  <DeleteButton
                    open={confirmar_exclusao && id_item_atual === item?.cod}
                    trigger={setConfirmar_exclusao}
                    onTrigger={() => {
                      setId_item_atual(item?.cod)
                      setNome_item_atual(item?.nome)
                    }}
                    loading={fake_loading}
                    message={`o item ${item?.nome} será excluido!`}
                    deleteds={[item?.nome]}
                    onDelete={() => {
                      deletar(item?.cod)
                    }}
                    disabled={fake_loading}
                    disabledTrigger={permissao?.exclusao === 0}
                    textButtonTrigger='Excluir'
                    typeButtonTrigger='secondary'
                  />
                  <ButtonCustom
                    icon={<FontAwesomeIcon icon={faEdit} />}
                    onClick={() => {
                      editar(item?.cod, item)
                    }}
                    disabled={permissao?.alteracao === 0 && permissao?.acesso === 0}
                  >
                    Editar
                  </ButtonCustom>
                </RowItem>
              </RowTable>
            )
          })}
        </Render>

        <Render condition={list_clientes.length === 0 && !loading}>
          {buscarTabela === '' ? (
            <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description={<> Nenhum registro disponível!</>}
            />
          ) : (
            <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description={
                <>
                  {' '}
                  <b>'{buscarTabela}'</b> não encontrado!
                </>
              }
            />
          )}
        </Render>

        <Render condition={loading}>
          <Carregando
            animation
            legenda='Carregando clientes...'
            justifyContent='center'
            height={400}
            size='default'
          />
        </Render>
      </BodyTable>
    </Box>
  )
}
